import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {
    IAccessTokenResponse,
    ICenterRoles,
    IChangePassword,
    ICredentials,
    IForgotPassword,
    IRefreshTokenRquest,
    IResetPassword,
} from '@evencel/models';
import {Observable} from 'rxjs';

const httpOptions = {withCredentials: true};

@Injectable({providedIn: 'root'})
export class LoginService {
    constructor(private httpClient: HttpClient) {}

    login(credentials: ICredentials): Observable<IAccessTokenResponse> {
        return this.httpClient.post<IAccessTokenResponse>('auth/login', credentials, httpOptions);
    }

    // TODO to support multipla centers
    getPolicies(): Observable<ICenterRoles> {
        return this.httpClient.get<ICenterRoles>('auth/policies');
    }

    logout(): Observable<void> {
        return this.httpClient.post<void>('auth/logout', {}, httpOptions);
    }

    refreshToken(refreshToken: IRefreshTokenRquest): Observable<IAccessTokenResponse> {
        return this.httpClient.post<IAccessTokenResponse>('auth/refresh-token', refreshToken);
    }

    resetPassword(resetPassword: IResetPassword): Observable<IAccessTokenResponse> {
        return this.httpClient.post<IAccessTokenResponse>('auth/reset-password', resetPassword);
    }

    changePassword(change: IChangePassword, params?: Record<string, boolean>): Observable<IAccessTokenResponse> {
        return this.httpClient.post<IAccessTokenResponse>('auth/change-password', change, {params});
    }

    forgotPassword(iForgotPassword: IForgotPassword): Observable<void> {
        return this.httpClient.post<void>('auth/forgot-password', iForgotPassword);
    }
}
